import React from 'react'
import { Box } from '@mantine/core'
import {
  CampaignTemplate,
  SiteTemplatePageDocument,
  SiteTemplatePageQuery,
  SiteTemplatePageQueryVariables,
} from 'types/domain'
import SiteLayout from 'components/site/SiteLayout'
import GridBackground from 'components/site/GridBackground'
import Template from 'modules/Site/Template'
import { Footer, GoToSignup } from 'components/site'
import Head from 'next/head'

import footerBgImage from 'assets/images/site/footer-bg.jpg'
import { GetServerSidePropsContext } from 'next'
import { addApolloState, initializeApollo } from 'plugins/apollo'
import getT from 'next-translate/getT'
import { fetchDataThatNeedErrorHandling, serverSideFetchData } from 'utils/serverSideFetchData'
import { deepCleanOptions } from 'utils/objectUtils'
import Divider from 'components/ui/Divider'
import { fetchDataWithErrorHandling } from 'utils/dataFetchError'

type Props = {
  template: CampaignTemplate
}

const TemplateDetailPage = ({ template }: Props) => {
  return (
    <SiteLayout>
      <Head>
        <title>
          {template.title}模板 - 浩客HowXM模板中心 - 应用内调研、评价、通知模板 - NPS 调研模板 - 评价反馈模板
        </title>
        <meta name="viewport" content="width=device-width, initial-scale=1.0"></meta>
        <style>
          {`body {
              min-width: 0 !important;
            }`}
        </style>
      </Head>
      <GridBackground>
        {!!template && <Template template={template} />}
        <Box
          className="pt-[159px]"
          sx={{
            background: `url('${footerBgImage.src}') no-repeat center -30px / 1064px 770px`,
          }}
        >
          <GoToSignup />
        </Box>
      </GridBackground>
      <Box className="mx-[53px]">
        <Divider mt={72} mb={48} />
      </Box>
      <Footer />
    </SiteLayout>
  )
}

export async function getServerSideProps(props: GetServerSidePropsContext) {
  const { locale, req, query } = props

  const client = initializeApollo()

  async function fetchData() {
    const t = await getT(locale, 'pageTemplate')
    const { data } = await serverSideFetchData<SiteTemplatePageQuery, SiteTemplatePageQueryVariables>({
      client: initializeApollo(),
      fetchPolicy: 'no-cache',
      query: SiteTemplatePageDocument,
      variables: {
        id: query.templateId as string,
      },
      req,
    })
    const cleanDeep = require('clean-deep')
    const template = cleanDeep(data?.campaignTemplate, deepCleanOptions)
    return addApolloState(client, {
      props: {
        pageTitle: t('pageTemplate:title'),
        pageKeywords: `${template.title}模板，NPS调研模板,评价反馈模板,满意度调研模板,应用内调研模板,横幅通知模板,用户调研模板`,
        pageDescription: `${template.description} 浩客HowXM，数字化系统的应用内调研、评价、通知工具，简单好用的用户体验分析工具。比如：NPS 净推荐值调研，CSAT 满意度调研，评价反馈模板，新功能通知，促销通知模板，付费流失原因调研，A/B 版本测试，新功能引导模板等。`,
        template,
      },
    })
  }

  return await fetchDataWithErrorHandling(async () => fetchDataThatNeedErrorHandling(props, fetchData))
}

export default TemplateDetailPage
